import BUApi from './_buApi';

class BUCommitmentAdjustmentAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUCommitmentAdjustments';
}

export default new BUCommitmentAdjustmentAPI();
